import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Card, CardContent, Typography, Button } from "@mui/material";

const redirect_uri = 'https://admin.remind4u.co.kr/api/google/callback'

const LoginPage = () => {
  const [codeClient, setCodeClient] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const loadGoogleScript = () => {
      const script = document.createElement('script');
      script.src = 'https://accounts.google.com/gsi/client';
      script.async = true;
      script.defer = true;
      script.onload = () => {
        const client = window.google.accounts.oauth2.initCodeClient({
          client_id: '370995693106-or1lefk94vrvgdj4cbg4409fa1rk10o5.apps.googleusercontent.com',
          scope: 'https://www.googleapis.com/auth/devstorage.read_only https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/cloud-platform',
          redirect_uri: redirect_uri,
          response_type: 'code',
          ux_mode: 'redirect', // 로그인 후 자동 리디렉션
          callback: (response) => {
            if (response.code) {
              // 서버로 인증 코드만 보내고, 서버가 토큰을 교환하고 리디렉션 처리
              window.location.href = `/google/callback?code=${response.code}`;
            }
          },
        });
        setCodeClient(client);
      };
      document.body.appendChild(script);
    };
    loadGoogleScript();
  }, []);

  const handleLogin = () => {
    if (codeClient) {
      // Google OAuth 코드 요청
      codeClient.requestCode();
    } else {
      console.error("Google OAuth 클라이언트가 초기화되지 않았습니다.");
    }
  };

  useEffect(() => {
    const getTokenFromBackend = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get("code");

      if (code) {
        try {
          // Send the code to the backend to exchange for a JWT token
          const response = await fetch("/google/callback", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ code }),
          });

          if (response.ok) {
            const data = await response.json();
            const { token } = data;

            // Store the token in localStorage or sessionStorage
            localStorage.setItem("jwtToken", token);

            // Navigate to the dashboard or another page after successful login
            navigate("/dashboard");
          } else {
            console.error("Token exchange failed");
          }
        } catch (error) {
          console.error("Error exchanging code for token:", error);
        }
      }
    };

    getTokenFromBackend();
  }, [navigate]);

  return (
    <Container style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <Card style={{ padding: '2rem', textAlign: 'center' }}>
        <CardContent>
          <Typography variant="h5" style={{ marginBottom: '2rem' }}>
            대시보드 로그인
          </Typography>
          <Button variant="contained" color="primary" onClick={handleLogin}>
            Google로 로그인
          </Button>
        </CardContent>
      </Card>
    </Container>
  );
};

export default LoginPage;
